
import { defineComponent } from "vue"

export default defineComponent({
	setup() {
		const date = new Date()
		const currentYear = date.getFullYear()

		return { currentYear }
	}
})
